<template>
  <modal v-if="settings && popup_open && popup_name === 'password-setup-modal'" :closeable="false"
         class="tw-relative"
         modal_name="password-setup-modal"
         type="xlarge">
    <template v-slot:modal-content>
      <span class="tw-text-lg tw-font-semibold tw-text-black tw-mb-3 tw-mt-2 tw-block">
        {{ $t('login.choose_a_password') }}
      </span>
      <p class="tw-mb-6 light-text">{{ $t('login.login_with_this_password') }}</p>
      <validation-observer ref="modal-password-setup-modal">
        <form-row class="tw-gap-4 !tw-mb-0">
          <form-field>
            <form-input v-model="new_password" :autofocus="true" name="new_password" :placeholder="$t('fields.password')" @keydown.enter="setNewPassword()"
                        rules="required|min:8" type="password" @input="updatePasswordStrength()"></form-input>
            <span v-if="backend_error" class="form-validation-error">{{ backend_error }}</span>
          </form-field>
        </form-row>
        <div class="tw-my-2 tw-w-full tw-overflow-hidden tw-rounded tw-bg-gray-100">
          <div
            :style="`width: ${password_strength_meter * 25}%; background-color: ${barColor};`"
            class="tw-h-1 tw-transition-all tw-delay-150"></div>
        </div>
        <p class="tw-mt-6 tw-font-semibold tw-text-gray-600">{{ $t('login.the_password_contains') }}</p>
        <div class="tw-mt-4 tw-grid tw-gap-3 tw-grid-cols-2">
          <PasswordStrenghtIndicator
            v-model="password_length_valid"
            :translation="$t('login.minimum_8_characters')"/>
          <PasswordStrenghtIndicator
            v-model="password_has_number"
            :translation="$t('login.minimum_1_number')"/>
          <PasswordStrenghtIndicator
            v-model="password_has_uppercase"
            :translation="$t('login.minimum_1_uppercase')"/>
          <PasswordStrenghtIndicator
            v-model="password_has_special_char"
            :translation="$t('login.minimum_1_special_character')"/>
        </div>
      </validation-observer>
    </template>
    <template v-slot:modal-bottom>
      <div class="general-button btn-v2 slim full-width" tabindex="0" @click="setNewPassword()"
           @keydown.enter="setNewPassword()">
        {{ $t('admin.confirm') }}
        <i v-if="submitting" class="fal fa-spinner fa-spin"></i>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@/resources/assets/js/vue/mixins/v2/Modal';
import Global from "../../mixins/Global";
import PasswordStrenghtIndicator from "./PasswordStrenghtIndicator";

export default {
  name: 'OnboardingProfileModal',
  components: {
    PasswordStrenghtIndicator
  },

  mixins: [Modal, Global],

  data() {
    return {
      user,
      new_password: "",
      backend_error: false,
      submitting: false,
      password_length_valid: false,
      password_has_number: false,
      password_has_uppercase: false,
      password_has_special_char: false,
      password_strength_meter: 0,
      tenant_id,
    };
  },

  computed: {
    barColor() {
      switch (this.password_strength_meter) {
        case 0:
          return "#cbd5e1"; // slate-100
        case 1:
          return "#f87171"; // red-500
        case 2:
          return "#f59e0b"; // amber-500
        case 3:
          return "#fbbf24"; // amber-400
        case 4:
          return "#10b981"; // emerald-500
        default:
          return "#cbd5e1"; // slate-100 fallback
      }
    },
  },

  methods: {
    updatePasswordStrength() {
      this.password_length_valid = this.new_password.length >= 8;
      this.password_has_number = /\d/.test(this.new_password);
      this.password_has_uppercase = /[A-Z]/.test(this.new_password);
      this.password_has_special_char = /[!@#$%^&*(),.?":{}|<>]/.test(this.new_password);

      this.password_strength_meter = [
        this.password_length_valid,
        this.password_has_number,
        this.password_has_uppercase,
        this.password_has_special_char,
      ].filter(Boolean).length;
    },

    async setNewPassword() {
      if (!this.submitting) {
        this.submitting = true;
        this.backend_error = false;

        this.validateModal(false).then(async () => {
          try {
            await axios.post(
              "/api/v4/users/password",
              {
                password: this.new_password,
                password_confirmation: this.new_password,
              },
              {
                headers: {
                  "Tenant-Id": this.tenant_id,
                },
              },
            );

            window.location.reload();
          } catch (e) {
            this.submitting = false;
            const errors = e.response.data.errors;

            // get the first error message
            if (errors) {
              this.backend_error = errors[Object.keys(errors)[0]][0];
            }
          }
        }).catch(() => {
          this.submitting = false;
        });
      }
    },
  },
};
</script>